module.exports = __webpack_public_path__ + "static/media/ios-reverse-camera.84910f20.svg";